export type PlayModeKey = 'quiz' | 'poll' | 'checkin' | 'photo' | 'draw';

export const playModes: Array<{
  key: PlayModeKey;
  title: string;
  description: string;
  note: string;
  image: string;
}> = [
  {
    key: 'quiz',
    title: 'Quiz',
    description: 'A short branded question flow. You see the rules before you start, and it’s done in moments.',
    note: 'Rules shown up front',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5b50be48-200c-4de5-9577-2de420000ee5.jpg',
  },
  {
    key: 'poll',
    title: 'Poll',
    description: 'Share what you think. Brands only see totals from large enough groups, never your individual answers.',
    note: 'Group totals only',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d8f8c361-569d-4c6c-a160-60b19c109ec9.jpg',
  },
  {
    key: 'checkin',
    title: 'Check-in',
    description: 'Scan the QR code at the venue to confirm you’re there. Optional, and no continuous GPS tracking.',
    note: 'QR, not GPS',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/516ef107-4d6b-4e20-b94e-27c564b09b2f.jpg',
  },
  {
    key: 'photo',
    title: 'Photo mission',
    description: 'Capture a moment at the event. Uploads are moderated, and publishing needs your separate permission.',
    note: 'Published only with your OK',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b72d6da3-946c-4373-8d55-9e3e5f6a05fa.jpg',
  },
  {
    key: 'draw',
    title: 'Prize draw',
    description: 'Winners are chosen by rules fixed in advance. Every draw is reproducible and leaves an audit record.',
    note: 'Fair and checkable',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/9809d41f-da53-4b13-9009-94157b85dfe3.jpg',
  },
];
